import { Component, Inject } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';

@Component({
  selector: 'lum-ui-pull-inbound-shipments-dialog',
  templateUrl: './ui-pull-inbound-shipments-dialog.component.html',
})
export class UiPullInboundShipmentsDialogComponent {
  public daysPast :any = 60;

  constructor(
    public dialogRef :MatDialogRef<UiPullInboundShipmentsDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data :{},
  ) {}

  setDays(event :Event) :void {
    this.daysPast = (event.target as HTMLInputElement).value;
  }

  onConfirmClick(event :Event) :void {
    event.preventDefault();

    this.dialogRef.close({
      confirmed: true,
      days: parseInt(this.daysPast) ?? 60,
    });
  }

  onCancelClick() :void {
    this.dialogRef.close({
      confirmed: false,
    });
  }
}
